import React, { useEffect, useState } from "react";

import MainLayout from "../../layouts/MainLayout";

import DeleteModal from "../../modals/DeleteModal";
import useGetRepeats from "../../../hooks/repeat/useGetRepeats";
import { IRepeat } from "../../../types/repeat";
import SideBar from "../../subcomponents/repeat/Sidebar";
import Repeat from "../../subcomponents/repeat/Repeat";

const Repeats = () => {
  const [currOption, setCurrOption] = useState<number[]>([]);
  const [repeats, setRepeats] = useState<IRepeat[]>([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    setCurrOption([0]);
  }, []);

  const { data, isPending, isError } = useGetRepeats();

  useEffect(() => {
    if (!isError && !isPending) setRepeats([...data]);
  }, [data, isPending, isError]);

  if (isPending) return <p>Loading...</p>;
  if (isError) return <p>Error!!</p>;

  if (repeats.length === 0) {
    return <p>Loading....</p>;
  }

  return (
    <MainLayout>
      {isOpenDeleteModal && (
        <DeleteModal
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          setIsDelete={setIsDelete}
          title="Are you sure you?"
          subtitle="This is an irrecoverable action. All data will be lost."
        />
      )}
      <div className="imm_quest_admin__main_view">
        <SideBar
          currOption={currOption}
          repeats={repeats}
          setRepeats={setRepeats}
          setCurrOption={setCurrOption}
        />

        <div className="imm_quest_admin__main_content">
          {currOption.length === 1 && (
            <Repeat
              currOption={currOption}
              setCurrOption={setCurrOption}
              repeats={repeats}
              isDelete={isDelete}
              setIsDelete={setIsDelete}
              setIsOpenDeleteModal={setIsOpenDeleteModal}
            />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default Repeats;
